import { render, staticRenderFns } from "./GelirGiderInfo.vue?vue&type=template&id=304826f5&scoped=true"
import script from "./GelirGiderInfo.vue?vue&type=script&lang=ts"
export * from "./GelirGiderInfo.vue?vue&type=script&lang=ts"
import style0 from "./GelirGiderInfo.vue?vue&type=style&index=0&id=304826f5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304826f5",
  null
  
)

export default component.exports